import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import config from '../../config/config'
import './FeedbackInactivityPrompt.css'

const activityEvents = ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'scroll', 'wheel']

export default function FeedbackInactivityPrompt({ enabled, delaySeconds = 60 }) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (!enabled || isOpen) return undefined

    let timeoutId

    const clearPromptTimer = () => {
      window.clearTimeout(timeoutId)
    }

    const schedulePrompt = () => {
      clearPromptTimer()
      if (document.hidden) return

      timeoutId = window.setTimeout(() => {
        setIsOpen(true)
      }, delaySeconds * 1000)
    }

    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearPromptTimer()
      } else {
        schedulePrompt()
      }
    }

    activityEvents.forEach((eventName) => {
      window.addEventListener(eventName, schedulePrompt, { passive: true })
    })
    document.addEventListener('visibilitychange', handleVisibilityChange)
    schedulePrompt()

    return () => {
      clearPromptTimer()
      activityEvents.forEach((eventName) => {
        window.removeEventListener(eventName, schedulePrompt)
      })
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [enabled, delaySeconds, isOpen])

  const closePrompt = () => setIsOpen(false)

  if (!enabled) return null

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={closePrompt}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
      contentLabel="Help improve EMRD"
      className="feedback-prompt-modal"
      overlayClassName="feedback-prompt-overlay"
      bodyOpenClassName="feedback-prompt-open"
    >
      <section className="feedback-prompt">
        <div className="feedback-prompt-icon" aria-hidden="true">
          <i className="bx bx-message-dots" />
        </div>
        <p className="feedback-prompt-eyebrow">A quick question</p>
        <h2>Help us improve EMRD</h2>
        <p className="feedback-prompt-copy">
          Thank you for exploring the demo. What worked well, and what could be clearer?
          Your feedback and suggestions help us make the site more useful.
        </p>
        <div className="feedback-prompt-actions">
          <a
            className="feedback-prompt-submit"
            href={`mailto:${config.header.emailAddress}?subject=Feedback%20on%20EMRD%20demo`}
            onClick={closePrompt}
          >
            <i className="bx bx-envelope" aria-hidden="true" />
            Share feedback
          </a>
          <button className="feedback-prompt-dismiss" onClick={closePrompt}>
            Maybe later
          </button>
        </div>
      </section>
    </ReactModal>
  )
}